import { color } from "../../constants";

export default {
  underlineAlways: {
    color: color.BLACK
  }
};
